import React from "react";
import ScaledLogo from "./ScaledLogo";
import styles from "./materials.module.scss";

const InstagramTitle = ({ event, textColor, bgColor }) => (
  <div className={styles.igTitle} style={{ "--mat-bg": bgColor, "--mat-text": textColor }}>
    <div className={styles.igTitleTextContainer}>
      <span className={styles.igTitleLabel}>Meetup #{event.eventMeetupNo}</span>
      <span className={styles.igTitleName}>{event.eventName}</span>
    </div>
    <span className={styles.igTitleFooter}>{"Meetup link in bio "}</span>
    <div className={styles.igTitleLogo}>
      <ScaledLogo color={event.color} width={192} height={221} />
    </div>
  </div>
);

export default InstagramTitle;
